import { defineComponent as _defineComponent } from 'vue'
import { store } from '@/store';
import { ref, watch } from 'vue';
import { i18n } from '@/assets/i18n';

const MIN_WATT = 0;
const MAX_WATT = 500;


export default /*@__PURE__*/_defineComponent({
  __name: 'PowerSimulator',
  props: {
  debug: Boolean,
  watt: Number
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const simulatedWatt = ref(MIN_WATT);

watch(simulatedWatt, () => store.power.setDebugWatt(simulatedWatt.value));

function getBackgroundColor(): string {
  const calcWatt = (props.debug ? simulatedWatt.value : props.watt) || 0;
  const clamped = Math.max(0, Math.min(MAX_WATT, calcWatt));

  const green = { r: 182, g: 242, b: 195 };
  const yellow = { r: 255, g: 255, b: 102 };
  const red = { r: 139, g: 0, b: 0 };

  let start, end, t;

  if (clamped <= MAX_WATT / 2) {
    start = green;
    end = yellow;
    t = clamped / (MAX_WATT / 2);
  } else {
    start = yellow;
    end = red;
    t = (clamped - MAX_WATT / 2) / (MAX_WATT / 2);
  }

  return `background-color: rgba(${Math.round(start.r + (end.r - start.r) * t)}, ${Math.round(
    start.g + (end.g - start.g) * t
  )}, ${Math.round(start.b + (end.b - start.b) * t)}, 0.5)`;
}

const __returned__ = { MIN_WATT, MAX_WATT, props, simulatedWatt, getBackgroundColor, get i18n() { return i18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})